import React from 'react'
import { NavLink } from 'react-router-dom'

const locations = [
  {
    image: require('./../../images/our-history/1.jpg'),
    title: 'About Us',
    location: 'Building Foundations for Tomorrow',
    description:
      'Askala Company for General Trading Limited stands at the forefront of construction innovation as a premier provider of specialized formwork solutions and slab systems. With our comprehensive expertise in structural engineering and building technologies, we deliver cutting-edge formwork systems that enable the creation of complex concrete structures with precision, efficiency, and uncompromised safety. Our solutions cater to major construction projects across residential, commercial, and infrastructure developments.',
  },
  // {
  //   image: require('./../../images/our-history/2.jpg'),
  //   title: 'Steel Cookware - Pots & Pans Set',
  //   location: 'Sustainable and non-toxic materials ',
  //   description:
  //     'Replace your current pots and pans with our high quality materials',
  // },
  // {
  //   image: require('./../../images/our-history/3.jpg'),
  //   title: 'Kitchen Items ',
  //   location: '',
  //   description:
  //     // "The floor looks magnificent and the parquet in the hall sets it off beautifully. Your men were excellent, you were delightful and nothing was too much trouble for you. You have very tidy workers, covering everything, and the house was left in a good shape as the condition allowed.",
  //     "At Askala Company, we also sell all types of high-quality electric kitchen items at affordable prices. Whether you're looking to refresh your home decor or add a cozy touch, you'll find the perfect materials to suit your style and budget!",
  // },
  
]



class About4 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 p-b10 bg-white inner-page-padding">
          <div className="container">
            <div className="section-content ">
              <div className="our-history text-black">
                {locations.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col-12">
                      <div className="our-history-content m-b30">
                        <div className="large-title">
                          <h2 className="m-t0">{item.title}</h2>
                          <h4>{item.location}</h4>
                        </div>
                        <p>{item.description}</p>
                        {/* <NavLink
                          to={"/about-1"}
                          className="site-button-secondry btn-half"
                        >
                          <span> View All</span>
                        </NavLink> */}
                      </div>
                    </div>
                    <div className="col-12 pic-bg-border">
                      <div
                        className="our-history-pic bg-no-repeat bg-center bg-cover"
                        data-stellar-background-ratio="0.5"
                        style={{ backgroundImage: 'url(' + item.image + ')' }}
                      ></div>
                    </div>
                  </div>
                ))}
                {/* <div
                  className="text-center load-more-btn-outer"
                  style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                >
                  <button
                    id="loadMorebtn-5"
                    className="site-button-secondry btn-half"
                  >
                    <span>Load More</span>
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default About4
